module.exports = __webpack_public_path__ + "img/project_13.230cbc4c.jpg";